var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"svg-elem",class:_vm.name,style:(_vm.style),attrs:{"viewBox":_vm.viewBox,"role":"img"}},[(_vm.$slots.default)?_c('title',[_vm._t("default")],2):_vm._e(),_c('use',{attrs:{"xlink:href":_vm.href}})])}
var staticRenderFns = []

export { render, staticRenderFns }